import { all, call, put, takeLatest } from "redux-saga/effects";
import * as constants from "../constants/HBConstants";
import { getLoginUrlToken } from "../../services/HBService";
export function* systemsGetAll(action) {
  const { email } = action;
  try {
    const ans = yield call(getLoginUrlToken, email);
    const data = ans.data
    yield put({ type: constants.HB_GET_URL_SUCCEEDED, data });
  } catch (error) {
    yield put({ type: constants.HB_GET_URL_FAILED, error });
  }
}

export function* watchHB() {
  yield all([takeLatest(constants.HB_GET_URL_REQUESTED, systemsGetAll)]);
}